export enum ArticleContentVariation {
  Text = 'text',
  TextAndImage = 'text_and_image',
  TextAndRoundImage = 'big_text_and_round_image',
  TextOnImage = 'text_on_image',
  TextBoxDashedDark = 'text_box_dashed',
  TextBoxDashedLight = 'text_box_dashed_light',
  TextBoxSolidLight = 'text_box_solid',
  TextBoxSolidDark = 'text_box_solid_dark',
  ReflectionBox = 'reflection_box',
}
